import React from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { TextSpot } from '@/style-guide'
import { Button } from 'antd'

export const RequestBookButton = ({
  trip,
  currentUser,
  showLogin = () => { },
}) => {
  // console.log('RequestBookButton props:', { trip, currentUser })
  const history = useHistory()
  const {
    bookingDetails,
    bookingId,
    _id,
    isArchived,
    spotsAvailable,
    maxGroupSize,
    groupSize,
    isOpenDatesMode,
    startBookingDate,
    lastBookingDate,
    ctaButtonColor,
  } = trip || {}

  const ctaStyle = ctaButtonColor
    ? { backgroundColor: ctaButtonColor, borderColor: ctaButtonColor }
    : {}
  const manageBooking = (bookingDetails) => {
    if (bookingDetails && bookingDetails.status == 'pending')
      history.push(`/dashboard/booking-requests/${bookingDetails._id}`)
    else history.push(`/dashboard/confirmed-events/${bookingDetails._id}`)
  }

  const checkout = async (_id) => {
    history.push(`/event/${_id}/book`)
  }
  const disabledRequestButton = 1;
  const currentDate = parseInt(moment().format('YYYYMMDD'))
  const isBookingDisabled = 
        isArchived ||
        currentDate < startBookingDate || // A) Booking has not opened yet
        currentDate > lastBookingDate || // B) Booking has already closed
        spotsAvailable === 0 ||
        (maxGroupSize - groupSize) === 0;
  const validSpots = (x) => {
    if (isArchived) {
      return <>This event is archived</>
    }
    if (currentDate < startBookingDate && !isOpenDatesMode) {
      return <>Booking opens on {moment(startBookingDate, "YYYYMMDD").format('ll')}</>;
    }
    if (currentDate > lastBookingDate && !isOpenDatesMode) {
      return <>The host is no longer accepting bookings.</>
    }
    if (x === 0) {
      return <>This event is sold out!</>
    }
    if (x === 1) {
      return <>{x} spot left</>
    }
    if (x > 1 && x < 5) {
      return <>{x} spots left</>
    }
    return ''
  }
  return (
    <>
      {((!isBookingDisabled || (bookingId && ['approved', 'pending'].includes(bookingDetails?.status))) || isOpenDatesMode) && (
          <Button
            className="manage-booking-btn"
            size="large"
            type="primary"
            style={ctaStyle}
            onClick={() => {
              if (
                bookingId &&
                ['approved', 'pending'].includes(bookingDetails?.status)
              )
                manageBooking(bookingDetails)
              else {
                checkout(_id)
              }
            }}
          >
            {bookingId && ['approved', 'pending'].includes(bookingDetails?.status)
              ? bookingDetails?.status === 'pending'
                ? 'Manage booking request'
                : 'Manage booking'
              : trip?.ctaButtonLabel || (trip?.autoAcceptBookingRequest === true
                ? 'Register'
                : 'Request to book')}
          </Button>
        )}
      {!['approved', 'pending'].includes(bookingDetails?.status) && (
        <TextSpot>
          {typeof spotsAvailable === 'number'
            ? validSpots(spotsAvailable)
            : validSpots(maxGroupSize - groupSize)}
        </TextSpot>
      )}
    </>
  )
}
